export default "__VITE_ASSET__42379c67__"